import {
  getStorageLocations,
  removeStorageLocation,
  setStorageLocationFilters,
  updateStorageLocation,
} from '@state/reducers/storageLocationReducer'
import { GridColumns } from '@mui/x-data-grid-pro'
import { StorageLocationDto } from '@services/dtos'
import { useEffect, useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import StorageLocationForm from '../forms/StorageLocationForm'
import { MonitoringMethodLabels, StorageTypeLabels } from '@utils/constants'

export default function StorageLocationsTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setStorageLocationFilters({ includeInactive: false }))
    }
  }, [])

  const columns: GridColumns<StorageLocationDto> = useMemo(
    () => [
      { field: 'name', headerName: 'Nom', width: 150 },
      {
        field: 'type',
        headerName: 'Type',
        width: 120,
        valueGetter: (params) => StorageTypeLabels[params.row.type],
      },
      { field: 'room', headerName: 'Salle', width: 80, valueGetter: (params) => params.row.room.label },
      {
        field: 'monitoring',
        headerName: 'Monitoring',
        width: 100,
        valueGetter: (params) => MonitoringMethodLabels[params.row.monitoring],
      },
      { field: 'capacityL', headerName: 'Capacité (L)', width: 100, type: 'number' },
      { field: 'setpointC', headerName: 'Consigne (°C)', width: 110, type: 'number' },
      { field: 'rangeMinC', headerName: 'Min (°C)', width: 80, type: 'number' },
      { field: 'rangeMaxC', headerName: 'Max (°C)', width: 80, type: 'number' },
      { field: 'alarmLowC', headerName: 'Alarme basse (°C)', width: 140, type: 'number' },
      { field: 'alarmHighC', headerName: 'Alarme haute (°C)', width: 140, type: 'number' },
      { field: 'notes', headerName: 'Notes', width: 300 },
    ],
    [],
  )

  return (
    <BaseConfigTable<StorageLocationDto>
      columns={columns}
      selectRows={(state) => state.storageLocation.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setStorageLocationFilters({ includeInactive: true }))
        return dispatch(getStorageLocations())
      }}
      deleteThunk={removeStorageLocation}
      toggleThunk={(id, isActive) => updateStorageLocation({ id, dto: { isActive } })}
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setStorageLocationFilters({ page }))
        dispatch(getStorageLocations())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <StorageLocationForm editingStorageLocation={editingItem} onClose={onClose} />
      )}
      resourceLabel="stockage"
      resourcePrefix="le "
    />
  )
}
